import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';

import { fetchSotyCategories } from '../../requests';

import { ShopOfTheYearNominationCategories } from '../../../../../../../../types';

import * as S from './styles';

type OwnProps = {
  visibleYear: number;
  sotyYears: number[];
  onDropdownChange: (
    categories: ShopOfTheYearNominationCategories | null,
    year: number
  ) => void;
};

const WinnersDropdown = ({
  visibleYear,
  onDropdownChange,
  sotyYears,
}: OwnProps) => {
  const { t } = useContext(AppContext);

  const getOptionString = (selectedYear: number) => {
    return t('campaigns', 'shop-of-the-year.winners-title', {
      year: selectedYear,
    });
  };

  const getSotyCategories = (y: number) => {
    fetchSotyCategories(y).then(response => {
      if (
        response.data &&
        response.data.shopOfTheYear &&
        !response.errors?.length
      )
        return onDropdownChange(response.data.shopOfTheYear.categories, y);

      return onDropdownChange(null, y);
    });
  };

  const renderToggleElement = () => (
    <S.DropdownToggle>
      {t('common', 'button.show')}
      <S.SelectedDropdownItem>
        {getOptionString(visibleYear)}
      </S.SelectedDropdownItem>
    </S.DropdownToggle>
  );

  return (
    <S.Dropdown
      variant="secondary"
      showArrow
      toggleElement={renderToggleElement()}
    >
      {sotyYears.sort().map(sotyYear => {
        return (
          <S.DropdownItem
            key={sotyYear}
            onClick={() => {
              getSotyCategories(sotyYear);
            }}
            disabled={Boolean(visibleYear === sotyYear)}
          >
            {getOptionString(sotyYear)}
          </S.DropdownItem>
        );
      })}
    </S.Dropdown>
  );
};

export default WinnersDropdown;
